const {
    METERS_SQUARED
} = require('../constants.js');

// Define component
const CalculatorAccordions = {
    props: {
        measure: {
            type: Boolean,
            default: true,
        },
    },
    
    setup(props) {
        const { ref, computed, watch, onMounted } = Vue;
        const { useStore } = Vuex;
        
        const store = useStore();

        const productType = computed(() => store.state.productType);
        const bulkTiers = computed(() => store.state.bulkTiers);
        const bulkDiscountPrice = computed(() => store.state.bulkDiscountPrice);
        const bulkOrderThreshold = computed(() => store.state.bulkOrderThreshold);
        const isDiscounted = computed(() => store.getters.isDiscounted);
        const packsNeeded = computed(() => store.getters.packsNeeded);
        const computedArea = computed(() => store.getters.computedArea);
        const bulkAccordionRef = ref(null);

        const accordionState = ref({
            howToMeasure: false,
            bulkPricing: false,
        });

        const getPricingTier = (tierValue, index) => {
            let tierDisplay = tierValue;

            if (store.state.productType == "pack") {
                if (bulkTiers.value[index + 1]) {
                    tierDisplay += " - " + (bulkTiers.value[index + 1].bulk_discount_qty - 1);
                } else {
                    tierDisplay += "+";
                }

                return tierDisplay + " packs";
            } else if (productType.value == 'accessory') {
                return tierDisplay + " units";
            } else {
                return tierDisplay + " " + METERS_SQUARED;
            }
        };

        const getDiscount = (value) => {
            let percentage = value / 100;
            let price = store.state.packSize
                ? store.state.defaultPrice / store.state.packSize
                : store.state.defaultPrice;
            let discount = price * percentage;

            return (price - discount).toFixed(2);
        };

        const isTierEnabled = (tier, index) => {
            if (store.state.productType == "pack" || store.state.productType == "accessory") {
                return (
                    tier.bulk_discount_qty <= packsNeeded.value &&
                    (index === bulkTiers.value.length - 1 ||
                        packsNeeded.value < bulkTiers.value[index + 1].bulk_discount_qty)
                );
            }

            return (
                tier.bulk_discount_qty <= computedArea.value &&
                (index === bulkTiers.value.length - 1 ||
                    computedArea.value < bulkTiers.value[index + 1].bulk_discount_qty)
            );
        };

        const slideToggle = async (key, slideTo = false) => {
            const contentEl = jQuery(`#${key}Content`);
            accordionState.value[key] = !accordionState.value[key];

            // Close all other accordions
            for (const accordionKey in accordionState.value) {
                if (accordionKey !== key && accordionState.value[accordionKey]) {
                    accordionState.value[accordionKey] = false;
                    const otherContentEl = jQuery(`#${accordionKey}Content`);
                    otherContentEl.slideToggle();
                }
            }

            contentEl.slideToggle();

            if (slideTo) {
                bulkAccordionRef.value.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        };

        return {
            productType,
            bulkTiers,
            bulkDiscountPrice,
            bulkOrderThreshold,
            isDiscounted,
            packsNeeded,
            computedArea,
            bulkAccordionRef,
            accordionState,
            getPricingTier,
            getDiscount,
            isTierEnabled,
            slideToggle
        };
    },

    template: `
        <div class="mb-5">
            <div v-if="measure" class="calculator-accordion">
                <div class="flex items-center justify-between" @click="slideToggle('howToMeasure')">
                    <div class="text-sm font-semibold leading-none text-shades-700">
                        How to measure
                    </div>
                    <div>
                        <svg width="13" height="10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                        </svg>
                    </div>
                </div>
                <div id="howToMeasureContent" class="hidden text-sm text-shades-500">
                    <div class="pt-4 font-normal">
                        To measure your room for flooring, start by using a tape measure to
                        find the length and width of the room. Measure from wall to wall at
                        the longest points. For rooms with alcoves or closets, measure those
                        areas separately. If the room has an irregular shape, divide it into
                        smaller rectangles and measure each section individually.
                    </div>
                </div>
            </div>
        </div>
    `
};

// Export the component using module.exports
module.exports = { CalculatorAccordions }; 